<template>
  <div>
    <!-- Delete Model -->
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteUser" />
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-add-patient"
      ok-only
      centered
      size="lg"
      :title="createMode ? $t('Add Patient') : $t('Edit Patient')"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('clinic.mother-name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="EditForm.mother_name"
                :placeholder="$t('clinic.mother-name')"
              />
              <p class="text-danger mt-1">{{ errorForm.mother_name }}</p>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('reception.phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="EditForm.phone"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                default-country-code="IQ"
                :error="
                  EditForm.phone ? isNotValid || EditForm.phone[0] != 0 : false
                "
              />
              <p class="text-danger mt-1">{{ errorForm.phone }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.birth-date')"
              label-for="entry_date"
            >
              <datepicker
                v-model="EditForm.birth_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
              <p class="text-danger mt-1">{{ errorForm.birth_date }}</p>
              <p class="text-danger mt-1">{{ errorForm.amount }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('reception.gender')" label-for="Gender">
              <v-select
                v-model="EditForm.gender"
                :options="genderOption"
                :placeholder="$t('reception.gender')"
              />
              <p class="text-danger mt-1">{{ errorForm.gender }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <AutoComplete
              :label="$t('reception.governorate')"
              :placeholder="$t('reception.governorate')"
              v-model="EditForm.governorate_id"
              param-query="search"
              endpoint="governorate"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.governorate_id }}</p>
          </b-col>

          <b-col md="6">
            <!-- <AutoComplete
              :label="$t('reception.city-name')"
              :placeholder="$t('reception.city-name')"
              v-model="EditForm.city_name"
              :serializer="(val) => val.name"
              param-query="search"
              endpoint="city"
              text-title="name"
            /> -->
            <b-form-group
              :label="$t('reception.city-name')"
              label-for="city_name"
            >
              <b-form-input
                id="city_name"
                v-model="EditForm.city_name"
                :placeholder="$t('reception.city-name')"
              />
            </b-form-group>
            <p class="text-danger mt-1">{{ errorForm.city_name }}</p>
          </b-col>
          <!-- <b-col cols="12">
            <ServicePriceAutoComplete
              :label="$t('hospital.services')"
              :placeholder="$t('hospital.services')"
              :serializer="(val) => val"
              param-query="search"
              text-title="title"
              @val="serviceValue($event)"
              :error-amount="errorForm.amount"
            />
            <p class="text-danger mt-1">{{ errorForm.service_id }}</p>
          </b-col> -->
          <!-- <b-col md="12">
            <b-form-group
              :label="$t('reception.patient-case')"
              label-for="Case"
            >
              <b-form-input
                id="Case"
                v-model="EditForm.patient_case"
                :placeholder="$t('reception.patient-case')"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <b-form-group :label="$t('lab.refered_by')" label-for="referred_by">
              <!-- <b-form-input
                id="referred_by"
                v-model="EditForm.referred_by"
                :placeholder="$t('lab.refered_by')"
                list="referred_by_list"
              />
              <datalist id="referred_by_list">
                <option value="Herself">Herself</option>
                <option value="Himself">Himself</option>
                <option
                  v-for="doctor in doctors"
                 
                >
                  {{ doctor.name }}
                </option>
              </datalist> -->
              <v-select
                v-model="EditForm.referred_by"
                :options="doctors"
                :placeholder="$t('lab.refered_by')"
                taggable
                :serializer="(val) => val.label"
              />

              <p class="text-danger mt-1">{{ errorForm.referred_by }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="submitItem" :disabled="loading">
          <span v-if="!loading">
            {{ createMode ? $t("common.add") : $t("common.edit") }}</span
          >
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Search -->
    <b-card no-body>
      <!-- Search Patient Name -->
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.search") }}</h2>
            <br />
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <h4>{{ $t("common.patient-name") }}</h4>
            <b-form-group :label="$t('common.patient-name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('common.patient-name')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="1">
            <br />
          </b-col>
          <!-- add Patient's Mother name -->
          <!-- we can delete the spaces created by the errors handler using the br below -->
          <!-- <br v-if="!errorForm.first_name && !errorForm.second_name && !errorForm.third_name && !errorForm.forth_name " />  -->
          <b-col md="5" cols="12">
            <h4>{{ $t("reception.patient-mother-name") }}</h4>
            <b-form-group
              :label="$t('reception.patient-mother-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientMotherName"
                :placeholder="$t('reception.patient-mother-name')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="index()" class="mx-2">
              {{ $t("common.search") }}
              <b-icon-search
                class="ml-1"
                style="font-size: smaller"
              ></b-icon-search>
            </b-button>
            <b-button
              v-if="$store.state.app.permissions.includes('store-patient')"
              variant="primary"
              @click="show(EditForm, 'create')"
            >
              {{ $t("common.Add Patient") }}
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Data Table  -->
      <b-table
        :items="patientsData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching patients found"
        class="position-relative"
        v-if="!loading"
      >
        <template #cell(birth_date)="data">
          <span class="text-nowrap">
            {{ data.item.birth_date }}
          </span>
        </template>
        <!-- Column: Phone -->
        <!-- <template #cell(Phone)="data">
          <span class="text-nowrap">
            {{ data.item.phone }}
          </span>
        </template> -->
        <template #cell(phone)="data">
          {{ formatPhoneNumber(data.item.phone) }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap d-flex">
            <ActionsButtons
              deletePerm="delete-patient"
              editPerm="update-patient"
              @editToggle="show(data.item, 'edit')"
              @deleteToggle="deleteModel(data.item)"
            />

            <!-- @click="printId(data.item.id)" -->
            <b-button
              class="mx-1"
              pill
              @click="
                $router.push({
                  name: 'patients-tests-details',
                  params: { id: data.item.patient_card.id },
                })
              "
              variant="outline-primary"
              size="sm"
            >
              {{ $t("common.preview") }}
            </b-button>
            <b-button
              pill
              size="sm"
              @click="
                $router.push({
                  name: 'patient-card-history',
                  params: { id: data.item.patient_card.patient.id },
                })
              "
              variant="outline-secondary"
            >
              {{ $t("reception.patient-history") }}
            </b-button>
          </div>
        </template>
      </b-table>

      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing 1 to 10 patients</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="index()"
          >
            <b-pagination
              v-model="page"
              :total-rows="pathientsNumber"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIcon,
  BIconSearch,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import formatPhoneNumber from "@/utils/formatPhoneNumber";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

const ServicePriceAutoComplete = () =>
  import("@/components/common/ServicePriceAutoComplete.vue");

export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BIcon,
    BIconSearch,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    StatisticCardHorizontal,
    ServicePriceAutoComplete,
    VuePhoneNumberInput,
    Datepicker,
    AutoComplete,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },

  data() {
    return {
      tableColumns: [
        { key: "name", sortable: true, label: this.$t("common.name") },
        {
          key: "description",
          sortable: true,
          label: this.$t("common.description"),
        },

        {
          key: "birth_date",
          sortable: true,
          label: this.$t("reception.birth-date"),
        },
        {
          key: "phone",
          sortable: true,
          label: this.$t("reception.phone"),
          class: "text-nowrap",
        },
        {
          key: "mother_name",
          sortable: true,
          label: this.$t("reception.patient-mother-name"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientName: "",
      patientMotherName: "",
      EditForm: {
        name: "",
        mother_name: "",
        phone: "",
        birth_date: "",
        gender: "",
        governorate_id: "",
        city_name: "",
        referred_by: "",
      },
      errorForm: {
        name: "",
        mother_name: "",
        phone: "",
        birth_date: "",
        gender: "",
        governorate_id: "",
        city_name: "",
        referred_by: "",
      },
      genderOption: ["Male", "Female"],
      addForm: {
        name: "",
        mother_name: "",
        gender: "",
        birth_date: "",
        type: "LAB",
        governorate_id: "",
        city_name: "",
        phone: "",
        referred_by: "",
        _method: "POST",
      },
      take: 10,
      loading: true,
      selected: "",
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      params: {
        form: {},
        path: "",
      },
      cities: [],
      city: "",
      patientsData: [],
      pathientsNumber: 0,
      deleteForm: [],
      statusFilter: null,
      filterData: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        patient_id: "",
        nickname: "",
      },
      createMode: false,
      doctors: [],
      isNotValid: false,
      referred_by: "",
    };
  },
  mounted() {
    this.index();
    this.getDoctorsList();
  },
  watch: {
    "EditForm.gender": {
      handler: function (newVal, oldVal) {
        console.log("newVal", newVal);
        console.log("oldVal", oldVal);
        if (newVal === "Male") {
          this.EditForm.referred_by = "Himself";
        } else if (newVal === "Female") {
          this.EditForm.referred_by = "Herself";
        }
      },
      deep: true,
    },
    "EditForm.referred_by": {
      handler: function (newVal, oldVal) {
        console.log("newVal", newVal);
        console.log("oldVal", oldVal);
        this.referred_by = newVal.label;
      },
      deep: true,
    },
  },
  methods: {
    formatPhoneNumber,
    showModelAddPatient() {
      this.$bvModal.show("modal-add-patient");
    },
    async getDoctorsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/doctor?take=100&sort=-id`;

      await this.getList(url);
      this.doctors = this.all_data.data;
      this.doctors = this.doctors.map((doctor) => {
        return {
          label: doctor.name,
        };
      });
      this.doctors.unshift({ label: "Herself" }, { label: "Himself" });
      console.log("doctors", this.doctors);
      this.loading = false;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm.name = "";
        this.EditForm.mother_name = "";
        this.EditForm.phone = "";
        this.EditForm.birth_date = "";
        this.EditForm.gender = "";
        this.EditForm.governorate_id = "";
        this.EditForm.city_name = "";
        this.EditForm.referred_by = "";
        this.EditForm.type = "LAB";
        this.EditForm.invoices = [
          {
            amount: 0,
          },
        ];
      } else if (mode === "edit") {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.mother_name = item.mother_name;
        this.EditForm.phone = item.phone;
        this.EditForm.birth_date = item.birth_date;
        this.EditForm.gender = item.gender;
        this.EditForm.governorate_id = item.governorate_id;
        this.EditForm.city_name = item.city_name;
        this.EditForm.referred_by = item.referred_by;
        this.EditForm._method = "PUT";
        console.log("EditForm", this.EditForm);
      }
      this.$bvModal.show("modal-add-patient");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    async index() {
      // after each time the search button being pressed the loading should be back again
      this.loading = true;
      // check if there are any null value in the obj we sending
      for (const [key, value] of Object.entries(this.filterData)) {
        if (value == null) {
          this.filterData[key] = "";
        }
      }

      let url = `/patient-lab?page=${this.page}&take=${this.take}&sort=-id&include=patientCard`;

      if (this.patientName) {
        url += `&filter[name]=${this.patientName}`;
      }
      if (this.patientMotherName) {
        url += `&filter[mother_name]=${this.patientMotherName}`;
      }
      await this.getList(url);
      this.pathientsNumber = this.all_data.total;
      this.patientsData = this.all_data.data;
      this.patientsData.forEach((patient) => {
        const referred_by = patient.patient_card.referred_by;
        patient.referred_by = referred_by;
      });
      this.loading = false;
    },
    serviceValue(service) {
      this.EditForm.service_id = service.id;
      this.EditForm.amount = service.price;
    },
    // async getCities() {
    //   await this.getList(`/city`);
    //   for (let item in this.all_data.data) {
    //     this.cities.push(this.all_data.data[item].name);
    //   }
    // },
    updateItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.referred_by = this.referred_by;
      console.log("EditForm", this.EditForm);
      (this.params.form = this.EditForm),
        (this.params.path = `/patient/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.index();
            this.$bvModal.hide("modal-add-patient");
            this.loading = false;
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    setName(name, value, blur) {
      if (blur != "blur") {
        this.nameValue = value;
      }
      if (blur == "blur") {
        this.addForm[name] = this.nameValue;
      }
    },
    deleteUser() {
      this.$store
        .dispatch("delete", `/patient/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.name,
            },
          });
        });
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      this.errorForm.mother_name = "";
      this.errorForm.gender = "";
      this.errorForm.birth_date = "";
      this.errorForm.phone = "";
      this.errorForm.governorate_id = "";
      this.errorForm.city_name = "";
      this.errorForm.referred_by = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      this.EditForm.birth_date = this.formatDate(this.EditForm.birth_date);
      this.EditForm.referred_by = this.EditForm.referred_by.label;
      // this.EditForm.invoices.push({
      //   service_id: this.EditForm.service_id,
      //   status: "pending",
      //   amount: this.EditForm.amount,
      // });

      // for (const item of Object.keys(this.errorForm)) {
      //   if (this.EditForm[item] === "" || this.EditForm[item] === null) {
      //     this.errorForm[item] = `The ${item} field is required.`;
      //     count++;
      //   }
      // }
      if (!this.EditForm.name) {
        this.errorForm.name = "The name field is required.";
        count++;
      }
      // if (!this.EditForm.mother_name) {
      //   this.errorForm.mother_name = "The mother name field is required.";
      //   count++;
      // }
      // if (!this.EditForm.phone) {
      //   this.errorForm.phone = "The phone field is required.";
      //   count++;
      // }
      if (!this.EditForm.birth_date) {
        this.errorForm.birth_date = "The birth date field is required.";
        count++;
      }
      // if (!this.EditForm.governorate_id) {
      //   this.errorForm.governorate_id = "The governorate field is required.";
      //   count++;
      // }
      // if (!this.EditForm.city_name) {
      //   this.errorForm.city_name = "The city name field is required.";
      //   count++;
      // }
      if (!this.EditForm.referred_by) {
        this.errorForm.referred_by = "The referred by field is required.";
        count++;
      }
      if (!this.EditForm.gender) {
        this.errorForm.gender = "The gender field is required.";
        count++;
      }

      if (count > 0) {
        console.log("errorForm", this.errorForm);
        console.log("count", count);
        this.loading = false;
        return false;
      }

      if (this.EditForm.governorate_id) {
        this.EditForm.governorate_id = this.EditForm.governorate_id.id;
      }
      delete this.EditForm.service_id;
      delete this.EditForm.amount;
      delete this.EditForm.status;

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `patientWithCard`),
          this.$store
            .dispatch("create", this.params)
            .then(async (response) => {
              this.index();
              this.loading = false;
              this.$bvModal.hide("modal-add-patient");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        this.updateItem();
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
